import { render, staticRenderFns } from "./viewClient.vue?vue&type=template&id=14950b99&scoped=true"
import script from "./viewClient.vue?vue&type=script&lang=js"
export * from "./viewClient.vue?vue&type=script&lang=js"
import style0 from "./viewClient.vue?vue&type=style&index=0&id=14950b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14950b99",
  null
  
)

export default component.exports